module.exports = __webpack_public_path__ + "static/media/esd-temperature.f7938671.png";